import { getLabel } from "../../../../../hooks/use-labels";
import { formatMoney } from "../../../../../features/orders/format";

const MasterPaymentCard = ({ master, supplierCount }) => {
  const total = master.paidAmount || master.total;
  const pending = master.payments.find((payment) => payment.pending);
  const codDue = pending?.amount || (master.payments.length ? null : master.codAmount);

  return (
    <div className="ord-master-payment">
      <div className="ord-master-payment-head">
        <span className="ord-master-payment-icon" aria-hidden="true">
          <img src="/assets/icons/order/empty-order-placeholder.svg" alt="" />
        </span>

        <span className="ord-master-payment-text">
          <span className="ord-master-payment-title">
            Paid once for {supplierCount} suppliers
          </span>

          <span className="ord-master-payment-sub">
            Each supplier below delivers its own order
          </span>
        </span>

        <span className="ord-master-payment-total">{formatMoney(total)}</span>
      </div>

      {master.payments.map((payment, index) => (
        <div key={payment.transactionId ?? index} className="ord-receipt-money">
          {payment.transactionId && (
            <div className="ord-receipt-row">
              <span className="ord-receipt-label">Transaction ID</span>
              <span className="ord-receipt-value">{payment.transactionId}</span>
            </div>
          )}

          <div className="ord-receipt-row">
            <span className="ord-receipt-label">
              {getLabel("paymentMethodLabel")}
            </span>
            <span className="ord-receipt-value">{payment.gatewayLabel}</span>
          </div>
        </div>
      ))}

      {codDue && (
        <p className="ord-cod-note">
          {formatMoney(codDue)} to be collected on delivery
        </p>
      )}
    </div>
  );
};

export default MasterPaymentCard;
